<avi-confirmation
    id="license-delete-dialog-confirmation"
    class="license-delete-dialog clr-wrapper"
    [headerText]="l10nKeys.deleteLicensesHeader | vtranslate"
    (onClose)="onClose.emit()"
    size="lg"
>
    <ng-container ngProjectAs="avi-confirmation_modal-content">
        <div class="license-delete-dialog__content-container">
            <p>{{ (licenses?.length > 1 ? l10nKeys.severalLicenseDeleteMessage : l10nKeys.singleLicenseDeleteMessage) | vtranslate }}</p>
            <avi-data-grid
                [config]="licensesGridConfig"
                [rows]="licenses"
            ></avi-data-grid>

            <p class="license-delete-dialog__confirm-message">{{ l10nKeys.deleteConfirmMessage | vtranslate }}</p>
        </div>
    </ng-container>

    <ng-container ngProjectAs="avi-confirmation_modal-actions">
        <cds-button
            action="outline"
            (click)="onClose.emit()"
            (keydown)="onClose.emit()"
            (keypress)="onClose.emit()"
            (keyup)="onClose.emit()"
        >
            {{ globalL10nKeys.closeLabel | vtranslate }}
        </cds-button>
        <cds-button
            status="danger"
            (click)="onDelete.emit()"
            (keydown)="onDelete.emit()"
            (keypress)="onDelete.emit()"
            (keyup)="onDelete.emit()"
        >
            {{ l10nKeys.deleteBtnLabel | vtranslate }}
        </cds-button>
    </ng-container>
</avi-confirmation>
